var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0H2C.9 0 0 .9 0 2v17c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#6983D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.77 16.746h7.444V4.588H12.77v12.158z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.537 10.666a7.718 7.718 0 002.953 6.078 7.732 7.732 0 110-12.158 7.718 7.718 0 00-2.953 6.08z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.666a7.732 7.732 0 00-12.51-6.078 7.732 7.732 0 010 12.158A7.733 7.733 0 0029 10.668v-.002z",
    fill: "#F79E1B"
  })));
}
export default SvgMastercardColor;